module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter4"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/004toc#january4"
    }
  }, [_vm._v("January 4")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You possess great courage and are unafraid to lead the charge when the battle cry sounds. This resolve will be invaluable to your commanders when you take part in the coming war between vampires and humans.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Beware of:")]), _vm._v(" Real stuffed animals")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image4"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image 4",
      "src": "images/StarRule.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ce298be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009chapter4.vue
// module id = 81
// module chunks = 0